import { DAM_ACCESS_TOKEN_COOKIE, DAM_TENANT_ID_COOKIE } from 'src/relay/damEnvironment';
import config from 'src/shared/config';
import { removeCookie } from 'src/shared/helpers';

export const Logout = ({ invalidateRelayStore, fromPricing }: { invalidateRelayStore: () => void; fromPricing?: boolean }) => {
    // For Users logged with googlelogin
    if ((window as any).gapi) {
        const _gapi = (window as any).gapi;
        if (_gapi && _gapi.auth2) {
            let auth2 = _gapi.auth2.getAuthInstance();
            auth2.signOut().then(function () {
                console.log('User signed out.');
            });
        }
    }

    invalidateRelayStore();

    removeCookie(DAM_ACCESS_TOKEN_COOKIE);
    removeCookie(DAM_TENANT_ID_COOKIE);

    var f = document.createElement('form');

    document.body.appendChild(f);
    f.action = fromPricing ? `${config.baseUrl}Auth/Logout?frompricing=true` : `${config.baseUrl}Auth/Logout`;
    f.method = 'POST';

    f.submit();
};
